import BaseService from './BaseService'
import _ from 'lodash'

export default class NotificationRouter extends BaseService {
  constructor(host, options) {
    super(host, options)

    const deleteKeys = []
    _.each(this.EVENTS, (fn, eventName) => {
      if (eventName.includes('|')) {
        deleteKeys.push(eventName)
        eventName.split('|').forEach(synonymEventName => (this.EVENTS[synonymEventName] = fn))
      }
    })
    deleteKeys.forEach(k => delete this.EVENTS[k])
  }

  emit(event) {
    if (this.EVENTS[event.type]) {
      this.EVENTS[event.type].call(this, event)
    } else {
      this.logger.info(`unhandled event: ${event.type}`, event.data)
    }
  }

  EVENTS = {
    ['message|group_message'](msg) {
      this.host.notifications.reactToMessageEvent(msg)
    },

    ['message:status|group:message:status'](msg) {
      this.host.notifications.reactToMessageStatusEvent(msg)
    },

    ['remote_wipe'](event) {
      this.host.notifications.disconnect()
      this.host.notifications.signOut({ fromServer: true })
    },

    ['sse:heartbeat']: () => null,
  }
}
